// extracted by mini-css-extract-plugin
module.exports = {"content":"IndexKv_content__aIExP"};